'use client'

import { version } from '@/root/VERSION'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export const Footer = () => {
    const pathname = usePathname()

    if (pathname.startsWith('/chat')) return null

    return (
        <footer className="w-full flex items-center justify-center gap-2 flex-wrap px-6 py-4 text-xs text-muted-foreground">
            <Link href="/terms" className="hover:underline">
                AGB
            </Link>
            <span className="opacity-50">·</span>
            <Link href="/privacy" className="hover:underline">
                Datenschutz
            </Link>
            <span className="opacity-50">·</span>
            <Link href="/imprint" className="hover:underline">
                Impressum
            </Link>
            <span className="opacity-50">·</span>
            <span>v{version}</span>
        </footer>
    )
}
